/* eslint-disable no-return-assign */
/* eslint-disable max-len */
/* eslint-disable no-console */
import React, { useContext, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { LoginContext } from '../App';
import { getNotification, initialChatFetchApi, getCompanyProfileData, getNotificationRedux, getSessionCount, getSharedItem, updateSideMenu } from '../redux/UserSessionSlice';
import { resetChat } from '../redux/ChatRedux';
import { resetFeed } from '../redux/NewsFeedRedux';
import { getCatRelations, getConnectionData, getNetworkRelations, getSuggestions, setFeedNetworkRelation, setFollowPopup } from '../redux/NetworkRedux';
import { getDepartmentRedux, getEmployeeIdRelation } from '../redux/DepartmentRedux';
import { getCertificateRedux, getExamRedux, getMarkingRedux, getQuestionBankRedux, getQuestionRedux, getTemplateRedux } from '../redux/CertificationRedux';
import { getOthersDealRedux, getDealRedux } from '../redux/DealRedux';
import { getEmployeeRedux } from '../redux/EmployeeRedux';
import { getReminderRedux, getTaskRedux } from '../redux/CollaborationRedux';
import { resetMediaKitData } from '../redux/MediakitRedux';
import { fetchResourceData } from '../redux/ResourceRedux';
import FullWidthLoader from '../components/Common/Loaders/FullWidthLoader';
import { fetchRecogniseData } from '../redux/RecogniseRedux';
import { updateMeetingData } from '../redux/TrainingRedux';
import { resetMyresourcesData } from '../redux/MyResourceRedux';
import '../containers/BusinessSettings/styles.css';
import { LanguageContext } from '../libs/Context';

const CertificationExamHoc = (WrappedComponent) =>
{
	return function NewComponent()
	{
		const { language } = useContext(LanguageContext);
		const session = useSelector((state:any) => state?.mysession?.session);
		const dispatch = useDispatch();
		const { loading } = useContext(LoginContext);
		const navigate = useNavigate();

		useEffect(() =>
		{
			if (Object.keys(session).length > 0)
			{
				// eslint-disable-next-line no-console
				if (session?.role === 'employee' &&
						(session?.isActive === 'pending' ||
						session?.isActive === 'reject' ||
							session.isActive === 'deactive'))
				{
					navigate('/emp');
				}
			}
			else
			{
				dispatch(resetFeed());
				dispatch(initialChatFetchApi(0));
				dispatch(resetChat());
				dispatch(getConnectionData({ value: 0, connectionCount: 0, mynetwork: [], pending: [], follow: [], block: [] }));
				dispatch(getNetworkRelations({ initialCount: 0, relations: [] }));
				dispatch(getSuggestions([]));
				dispatch(getDepartmentRedux({ departments: [], relations: [], divisions: [], designations: [], departmentView: {}, employeeCount: [] }));
				dispatch(getDealRedux({ approved: [], pending: [], reject: [], expired: [] }));
				dispatch(getOthersDealRedux({ approved: [], pending: [], reject: [], expired: [] }));
				dispatch(getCompanyProfileData({}));
				dispatch(getEmployeeRedux({ active: [], pending: [], reject: [], managers: [] }));
				dispatch(getTaskRedux({ pending: [], complete: [] }));
				dispatch(getReminderRedux({ upcoming: [], history: [] }));
				dispatch(getExamRedux([]));
				dispatch(getCatRelations([]));
				dispatch(getMarkingRedux({ publish: [], unPublish: [] }));
				dispatch(getQuestionRedux([]));
				dispatch(getQuestionBankRedux({ publish: [], unPublish: [] }));
				dispatch(getTemplateRedux({ publish: [], unPublish: [] }));
				dispatch(getCertificateRedux({ publish: [], unPublish: [] }));
				dispatch(resetMediaKitData());
				dispatch(getNotificationRedux({ notification: [] }));
				dispatch(fetchResourceData({
					categories        : [],
					subCategories     : [],
					content           : [],
					sections          : [],
					networkCategories : [],
					categoryData      : {}
				}));
				dispatch(setFeedNetworkRelation({ page: 0, relations: [] }));
				dispatch(getSessionCount(0));
				dispatch(setFollowPopup({ follow: [], following: [], mutual: [], companyId: '' }));
				dispatch(getNotification(0));
				dispatch(fetchRecogniseData({ published: [], unpublished: [] }));
				dispatch(getSharedItem(''));
				dispatch(updateMeetingData({ upcomingMeetings: [], pastMeetings: [] }));
				dispatch(resetMyresourcesData());
				dispatch(getEmployeeIdRelation(null));
				dispatch(updateSideMenu([]));
				navigate('/', { replace: true });
			}
		}, [ session ]);

		return (
			<div className='flexCol fullHeight'>
				{!loading && (
					<div className='innerMainCntnrContact'>
						<React.Suspense fallback={<FullWidthLoader />}>
							<WrappedComponent />
						</React.Suspense>
					</div>
				)}
			</div>
		);
	};
};

export default CertificationExamHoc;